import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router, RouterLink } from '@angular/router';
import { redirectIfNotSuperUser } from 'src/app/globals';
import { AdjustPasswordComponent } from './dialogs/adjust-password/adjust-password.component';
import { DeleteRidesComponent } from './dialogs/delete-rides/delete-rides.component';
import { CreateSepaForOrgsComponent } from './dialogs/create-sepa-for-orgs/create-sepa-for-orgs.component';
import { AddUserToOrgsComponent } from './dialogs/add-user-to-orgs/add-user-to-orgs.component';
import { NewOrganisationComponent } from './dialogs/new-organisation/new-organisation.component';
import { ManageParticularitiesComponent } from './dialogs/manage-particularities/manage-particularities.component';
import { CleanOrphanedOrganisationUsersComponent } from './dialogs/clean-orphaned-organisation-users/clean-orphaned-organisation-users.component';
import { BulkDeleteHiddenPassengersComponent } from './dialogs/bulk-delete-hidden-passengers/bulk-delete-hidden-passengers.component';
import { MatIcon } from '@angular/material/icon';
import { MatCard } from '@angular/material/card';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-admin-tools',
  templateUrl: './admin-tools.component.html',
  styleUrls: ['./admin-tools.component.scss'],
  imports: [MatIcon, MatCard, MatButton, RouterLink],
})
export class AdminToolsComponent implements OnInit {
  constructor(
    private dialog: MatDialog,
    private router: Router,
  ) {}

  ngOnInit(): void {
    redirectIfNotSuperUser(this.router);
  }

  async newOrganisation() {
    const dialogRef = this.dialog.open(NewOrganisationComponent, {
      width: '425px',
    });
  }

  async deleteRides() {
    const dialogRef = this.dialog.open(DeleteRidesComponent, {
      width: '425px',
    });
  }

  async adjustPassword() {
    const dialogRef = this.dialog.open(AdjustPasswordComponent, {
      width: '425px',
    });
  }

  async generateSepas() {
    const dialogRef = this.dialog.open(CreateSepaForOrgsComponent, {
      width: '425px',
    });
  }

  async addUserToOrgs() {
    const dialogRef = this.dialog.open(AddUserToOrgsComponent, {
      width: '425px',
    });
  }

  async manageParticularities() {
    const dialogRef = this.dialog.open(ManageParticularitiesComponent, {
      width: '425px',
    });
  }

  async cleanOrphanedOrganisationUsers() {
    const dialogRef = this.dialog.open(CleanOrphanedOrganisationUsersComponent, {
      width: '425px',
    });
  }

  async bulkDeleteHiddenPassengers() {
    this.dialog.open(BulkDeleteHiddenPassengersComponent, {
      width: '1000px',
    });
  }
}
